import { getCookies } from '@openclassrooms/utils/cookies/services';

import { COOKIE_NAME, API_LIVE_CONTENT_URL, PUBLIC_API_KEY } from '../constants/blueshift';

type BlueshiftLiveContent = {
  data: {
    show: boolean;
    content: {
      body: string;
      button: string;
      link: string;
      matchingUrl: string;
      isMatchingUrlRegExp: boolean;
      dataEvent: {
        type: string;
        category: string;
        action: string;
        label: string;
      };
    };
    tracking: {
      impression_url: string;
      click_url: string;
    };
  };
};

export default async function getBlueshiftLiveContent(
  slot: string,
  email?: string
): Promise<BlueshiftLiveContent | null> {
  const cookie = getCookies()[COOKIE_NAME];

  const url = new URL(API_LIVE_CONTENT_URL);
  url.searchParams.set('slot', slot);
  url.searchParams.set('x', PUBLIC_API_KEY);
  if (cookie) {
    url.searchParams.set('cookie', cookie.replace(/"/g, ''));
  }
  if (email) {
    url.searchParams.set('email', email);
  }

  try {
    const response = await fetch(url.toString());

    if (!response.ok) {
      return null;
    }

    const data = await response.json();

    return { data };
  } catch {
    return null;
  }
}
